exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".x{\r\n    margin: 1px;\r\n}\r\n\r\n@media only screen and (max-width: 768px) {\r\n    .left-box .list {\r\n        margin: 0 !important;\r\n    }\r\n    .profile-li-mobile{\r\n        padding: 0.2rem .4rem !important;\r\n    }\r\n    .left-box {\r\n        padding: 0 0.6rem !important;\r\n        max-height: 105px;\r\n    }\r\n    .left-profile-title-actions {\r\n        margin-left: 3px;\r\n        margin-bottom: 10px;\r\n    }\r\n    .card-title {\r\n        margin-bottom: 0;\r\n    }\r\n    .left-box .button-follow {\r\n        background-color: #fff !important;\r\n    }\r\n    .left-box .btn {\r\n        margin-bottom: 0 !important;\r\n        padding: 6px 54px;\r\n        border-radius: 3px;\r\n        background-color: #ef3b2b;\r\n        width: unset;\r\n        font-size: 13px;\r\n        margin-left: 57px;\r\n        top: -10px;\r\n        height: unset;\r\n    }\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/user-profile/user-profile.component.css
// module id = ../../../../../src/app/user-profile/user-profile.component.css
// module chunks = main